import { gql } from '@apollo/client';

export const DELETE_CREDENTIALS_CORREIOS = gql`
  mutation DeleteCorreiosCredentials($storeId: ID!) {
    deleteCorreiosCredentials(storeId: $storeId) {
      ... on DeleteCorreiosCredentialsSuccess {
        code
        message
      }
      ... on Error {
        code
        message
      }
    }
  }
`;
